import { API } from '../utils/static-data';
import axios from 'axios';
import { getAuthHeader } from '../utils/utils';

export class AuthService {

  static login = async (username, password) => {

    const creds = { username, password };
    const result = await axios.post(`${API}/user/login`, creds);

    if (result.status !== 200) {
      throw new Error(result.statusText);
    }

    return result.data;

  }

  static register = async (data) => {
    try {
      const result = await axios.post(`${API}/user/register`,
        data,
        {
          headers: {
            ...getAuthHeader()
          }
        });
      return result.data;
    } catch (error) {
      throw new Error(error.toString());
    }
  }

  static updateUser = async (data, id) => {
    try {
      const result = await axios.patch(`${API}/user/${id}`,
        data,
        {
          headers: {
            ...getAuthHeader()
          }
        });
      return result.data;
    } catch (error) {
      throw new Error(error.toString());
    }
  }

  static checkCurrentAuth = async () => {

    const token = localStorage.getItem("token");
    if (!token) return false;
    try {
      const result = await axios.get(`${API}/checkAuth`, {
        headers: {
          ...getAuthHeader()
        }
      });
      return result.status === 200;
    } catch (error) {
      return false;
    }

  }

}

export default AuthService;
